var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 11,
    viewBox: "0 0 46 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14893 0L0.0703125 10.9859H6.15013L6.90385 9.23427H8.62668L9.3804 10.9859H16.0726V9.64899L16.6689 10.9859H20.1306L20.7269 9.62073V10.9859H34.6448L36.3371 9.27975L37.9218 10.9859L45.0703 11L39.9757 5.52361L45.0703 0H38.0327L36.3853 1.67459L34.8505 0H19.7097L18.4095 2.83555L17.0789 0H11.0118V1.29139L10.3368 0C10.3368 0 5.14893 0 5.14893 0ZM6.32534 1.56001H9.28892L12.6576 9.00959V1.56001H15.9041L18.5059 6.90132L20.9039 1.56001H24.1342V9.4431H22.1686L22.1526 3.26595L19.287 9.4431H17.5287L14.6471 3.26595V9.4431H10.6035L9.83693 7.67581H5.69536L4.93036 9.44154H2.76385L6.32534 1.56001ZM25.9324 1.56001H33.9248L36.3692 4.14107L38.8925 1.56001H41.337L37.6228 5.52205L41.337 9.43844H38.7816L36.3371 6.8274L33.801 9.43844H25.9324V1.56001ZM7.76703 2.89378L6.40254 6.04206H9.12993L7.76703 2.89378ZM27.9061 3.19221V4.63126H32.2663V6.23521H27.9061V7.80624H32.7966L35.0691 5.49225L32.8931 3.19083L27.9061 3.19221Z",
    fill: "#016FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/_AmericanExpress.1df3dbf514afb40cdb637c20b118440f.svg";
export { ForwardRef as ReactComponent };